import { render, staticRenderFns } from "./LKAsideMenuItem.vue?vue&type=template&id=3ef9ba72&"
import script from "./LKAsideMenuItem.vue?vue&type=script&lang=js&"
export * from "./LKAsideMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./LKAsideMenuItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBadge,VProgressCircular})
